<template>
  <vk-modal-body>
    <services-modal-header>
      Showing results for <span class="text-bold text-italic c-depot">{{ query }}</span>
    </services-modal-header>
    <vk-modal-content>
      <div class="layout gap-1">
        <div
            v-for="(service, i) in results"
            :key="service.id"
            class="layout-item is-12 is-6:t">
          <div
              :selenium="`service-item:${i}`"
              class="link ellipsize"
              @click="$store.commit('homepage/request/setSelectedService', service);">
            {{ service.name }}
          </div>
        </div>
      </div>
    </vk-modal-content>
  </vk-modal-body>
</template>

<script>
import ServicesModalHeader from './components/ServicesModalHeader';
import ServicesModalBody from './components/ServicesModalBody';

export default {
  name: 'search-modal',
  components: {
    ServicesModalHeader,
    ServicesModalBody,
  },
  props: {
    query: {
      type: String,
      required: true,
    },
    results: {
      type: Array,
      required: true,
    },
  },
};
</script>
